import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaDownload } from "react-icons/fa";
import "./ProductsPage.css";

const ProductsPage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Dynamic calculation of years since company founding
  const yearsInBusiness = new Date().getFullYear() - 1989;

  const stats = [
    { value: "500+", label: "Spokojných klientov" },
    { value: "15+", label: "Produktov a riešení" },
    { value: "24/7", label: "Technická podpora" },
    { value: `${yearsInBusiness}+`, label: "Rokov skúseností" },
  ];

  // Všetky produkty a riešenia v jednom poli pre jednotný štýl
  const allProjects = [
    // Custom riešenia – nové
    {
      id: "lesenia",
      title: "Lešenia – Kalkulačný systém",
      subtitle: "Správa zákaziek a kalkulácií prenájmu lešení",
      description:
        "Webový systém pre firmy zaoberajúce sa prenájmom lešení. Umožňuje rýchle vytváranie kalkulácií ceny, správu zákaziek, automatické generovanie PDF dokumentov a odosielanie ponúk zákazníkom e-mailom. Všetko konfigurovateľné podľa potrieb klienta.",
      technologies: ["React", "Node.js", "PDF Export"],
      category: "Custom riešenie",
      link: "/produkty/lesenia",
      image: "/lesenia0.png",
    },
    // Hlavné produkty
    {
      id: "herkules",
      title: "HERKULES 3.0 WIN",
      subtitle: "Podvojné účtovníctvo",
      description:
        "Najnovšia verzia obľúbeného účtovníckeho programu Herkules vám prináša nové, príjemnejšie užívateľské prostredie a rad ďalších noviniek.",
      technologies: ["FoxPro", "Relačné databázy"],
      category: "Hlavný produkt",
      link: "/produkty/herkules",
      image: "/hercules.png",
    },
    {
      id: "spedicia",
      title: "Špedičný modul SPED",
      subtitle: "Logistické riešenia",
      description:
        "Špecializovaný modul určený pre logistické spoločnosti a prepravné firmy. Umožňuje kompletnú správu zásielok a vozového parku.",
      technologies: ["FoxPro", "Relačné databázy"],
      category: "Hlavný produkt",
      link: "/produkty/spedicia",
      image: "/spedicia.png",
    },
    // {
    //   id: 'predajna',
    //   title: 'POS systém PREDAJŇA',
    //   subtitle: 'Maloobchodný systém',
    //   description: 'Komplexný POS systém pre maloobchod a veľkoobchod. Efektívne riadenie predaja, skladu a zákazníkov na jednom mieste.',
    //   technologies: ['POS systém', 'E-shop integrácia', 'Vernostné programy'],
    //   category: 'Hlavný produkt',
    //   link: '/produkty/predajna'
    // },

    // Custom riešenia
    {
      id: "vysyp",
      title: "NAVIS",
      subtitle: "Inteligentný systém pre skladové areály",
      description:
        "Inteligentný systém na riadenie a navigáciu vodičov kamiónov v rámci skladových areálov – od registrácie po obslúženie na rampe. Automatické smerovanie podľa poradia, prehľadný manažment toku vozidiel a možnosť audiovizuálnej signalizácie.",
      technologies: ["React", "C#", "MSSQL", "SignalR", "MUI"],
      category: "Custom riešenie",
      link: "/produkty/vysyp",
      image: "/vysyp.png",
    },
    {
      id: "vyrobaweb",
      title: "VyrobaWeb",
      subtitle: "Digitalizácia výrobných procesov",
      description:
        "Digitalizácia a presun procesov z Excelu do moderného webového prostredia. Jednoduchšia správa, zdieľanie a reporting výrobných dát.",
      technologies: ["React", "C#", "MSSQL", "SignalR", "MUI"],
      category: "Custom riešenie",
      link: "/produkty/vyrobaweb",
      image: "/vyrobaweb.png",
    },
    {
      id: "bberp",
      title: "ERP",
      subtitle: "Komplexný ERP systém",
      description:
        "Komplexný ERP systém, ktorý spája všetky firemné procesy do jednej platformy – od skladov a objednávok až po dochádzku, plánovanie a reporting. Viacjazyčné, viacúrovňové riešenie s notifikáciami a modulmi pre rôzne tímy.",
      technologies: ["React", "C#", "MSSQL", "SignalR", "MUI"],
      category: "Custom riešenie",
      link: "/produkty/erp",
      image: "/erp.png",
    },
    {
      id: "kasaweb",
      title: "Webová stránka pre KASA ZÁLOŽNÁ akciová spoločnosť",
      subtitle:
        "Moderná prezentačná webová stránka spoločnosti poskytujúcej finančné služby formou záložného práva",
      description:
        "Moderná a responzívna webová stránka vytvorená pre spoločnosť KASA ZÁLOŽNÁ akciová spoločnosť. Stránka prezentuje služby spoločnosti, poskytuje prehľad ponúkaných pohľadávok a umožňuje jednoduchý kontakt so zákazníkmi. Riešenie je postavené na moderných technológiách s dôrazom na výkon, bezpečnosť a kvalitnú používateľskú skúsenosť.",
      technologies: ["React", "C#", "MSSQL", "SignalR", "MUI"],
      category: "Webové riešenie",
      link: "/produkty/kasa-web",
      image: "/kasaweb.jpg",
    },
    // Špeciálne projekty
    {
      id: "pizzaqueue",
      title: "PizzaQueue",
      subtitle: "Systém pre riadenie výroby pizze",
      description:
        "Moderný softvérový systém navrhnutý pre efektívne riadenie výroby pizze v reštauračných prevádzkach. Umožňuje presné plánovanie, sledovanie a optimalizáciu výrobných procesov v reálnom čase. Systém spracúva každú objednávku automaticky a zaraďuje ju do výrobnej fronty podľa aktuálneho vyťaženia kuchyne.",
      technologies: ["C#", "MSSQL"],
      category: "Špeciálny projekt",
      link: "/produkty/pizzaqueue",
      image: "/pizza_queue.png",
    },
    {
      id: "fastfood-pos",
      title: "FastFood POS",
      subtitle: "Pokladničný systém pre reštaurácie",
      description:
        "Flexibilný pokladničný systém určený pre reštauračné pobočky, ktorý spája jednoduchosť obsluhy, moderný dizajn a maximálnu efektivitu pri práci so zákazníkom. Systém umožňuje nasadenie dvoch typov pokladní – klasickej a kioskovej. Súčasťou je aj vernostný program a integrácia s platobnými terminálmi.",
      technologies: ["C#", "WPF", "MSSQL"],
      category: "Špeciálny projekt",
      link: "/produkty/fastfood-pos",
      image: "/fastfoodpos2.png",
    },
    {
      id: "zalozna",
      title: "Záložňa WIN",
      subtitle: "Aplikácia pre pobočky záložní",
      description:
        "Desktopová aplikácia pre Windows, navrhnutá na efektívne riadenie činnosti pobočiek záložní. Softvér slúži ako každodenný pracovný nástroj pre zamestnankyne pobočiek. Aplikácia je prepojená s API spoločnosti NIKÉ, poskytuje rozsiahly súbor reportov a štatistík, obsahuje integráciu s platobnými terminálmi.",
      technologies: ["C#", "MSSQL", "React"],
      category: "Špeciálny projekt",
      link: "/produkty/zalozna",
      image: "/zalozna.png",
    },
    {
      id: "pokladnicny-displej",
      title: "Zákaznícky displej",
      subtitle: "Moderný digitálny displej",
      description:
        "Moderný digitálny displej pre pokladne, ktorý nahrádza tradičné dvojriadkové zobrazovače. Zobrazuje viac informácií, ponúka lepší dizajn a počas neaktivity prehráva reklamné spoty.",
      technologies: ["React", "C#", "MSSQL", "SignalR"],
      category: "Custom riešenie",
      link: "/produkty/pokladnicny-displej",
      image: "/pokladnicny_displej.png",
    },
  ];

  return (
    <div className="products-page">
      {/* Hero Section */}
      <section className="products-hero">
        <h1>Naše IT riešenia</h1>
        <div className="hero-stats">
          {stats.map((stat, index) => (
            <div key={index} className="hero-stat">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Products Introduction Section */}
      <section className="products-intro">
        <div className="container">
          <div className="intro-content">
            <h2>Komplexné softvérové riešenia pre moderné podnikanie</h2>
            <p>
              Naše produkty a riešenia pokrývajú široké spektrum podnikových
              potrieb - od účtovníctva a logistiky až po komplexné ERP systémy
              vyvinuté na mieru. Každé riešenie je navrhnuté s dôrazom na
              efektívnosť, spoľahlivosť a jednoduché používanie.
            </p>
          </div>
        </div>
      </section>

      {/* All Projects List */}
      <section className="all-projects">
        <div className="container">
          <div className="projects-list">
            {allProjects.map((project, index) => (
              <div
                key={project.id}
                className={`project-row  ${index % 2 === 1 ? "reverse" : ""} ${project.id === "kasaweb" ? "kasaweb-project" : ""} ${project.id === "herkules" ? "herkules-project" : ""} ${project.id === "spedicia" ? "spedicia-project" : ""} ${project.id === "zalozna" ? "zalozna-project" : ""} ${project.id === "fastfood-pos" ? "fastfood-project" : ""} ${project.id === "pizzaqueue" ? "pizzaqueue-project" : ""} ${project.id === "pokladnicny-displej" ? "displej-project" : ""} ${project.id === "bberp" ? "erp-project" : ""} ${project.id === "vyrobaweb" ? "vyrobaweb-project" : ""} ${project.id === "vysyp" ? "vysyp-project" : ""} ${project.id === "lesenia" ? "lesenia-project" : ""}`}
              >
                <div
                  className={`project-image ${project.id === "kasaweb" ? "kasaweb-bg" : ""} ${project.id === "herkules" ? "herkules-bg" : ""} ${project.id === "spedicia" ? "spedicia-bg" : ""} ${project.id === "zalozna" ? "zalozna-bg" : ""} ${project.id === "fastfood-pos" ? "fastfood-bg" : ""} ${project.id === "pizzaqueue" ? "pizzaqueue-bg" : ""} ${project.id === "pokladnicny-displej" ? "displej-bg" : ""} ${project.id === "bberp" ? "erp-bg" : ""} ${project.id === "vyrobaweb" ? "vyrobaweb-bg" : ""} ${project.id === "vysyp" ? "vysyp-bg" : ""} ${project.id === "lesenia" ? "lesenia-bg" : ""}`}
                >
                  {project.image ? (
                    <img
                      src={project.image}
                      alt={project.title}
                      className="project-img"
                    />
                  ) : (
                    <div className="image-placeholder">
                      <span>📊</span>
                    </div>
                  )}
                  {project.category && (
                    <div className="project-category">{project.category}</div>
                  )}
                  {project.price && (
                    <div className="project-price">{project.price}</div>
                  )}
                </div>

                <div className="project-content">
                  <h3>{project.title}</h3>
                  <h4>{project.subtitle}</h4>
                  <p>{project.description}</p>

                  <div className="project-technologies">
                    {project.technologies.map((tech, techIndex) => (
                      <span key={techIndex} className="tech-tag">
                        {tech}
                      </span>
                    ))}
                  </div>

                  <div className="project-actions">
                    {project.link !== "#" ? (
                      <Link to={project.link} className="btn btn-primary">
                        Zistiť viac <FaArrowRight />
                      </Link>
                    ) : (
                      <button className="btn btn-secondary">Na mieru</button>
                    )}
                    {project.price && (
                      <button className="btn btn-download">
                        <FaDownload /> Demo
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;
